var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "bootom" }, [
        _vm._v("\n        License: MIT "),
        _c(
          "a",
          {
            staticStyle: { "margin-left": "2rem" },
            attrs: { href: "https://github.com/joel-ou/APopups-Gallery" }
          },
          [_vm._v("Github")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticStyle: { "margin-left": "2rem" },
            attrs: { href: "mailto:8019893@qq.com" }
          },
          [_vm._v("8019893@qq.com")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }